import { render, staticRenderFns } from "./Authorised_workshop.vue?vue&type=template&id=55375d4e&"
import script from "./Authorised_workshop.vue?vue&type=script&lang=js&"
export * from "./Authorised_workshop.vue?vue&type=script&lang=js&"
import style0 from "./Authorised_workshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports